<script setup>
  import { askLogin } from '@/utils/ask-login'

  const props = defineProps({
    job: { required: true, type: Object },
    color: { default: '#58d9db', type: String },
    hasApplied: { default: false, type: Boolean },
    isCareerSite: { default: false, type: Boolean }
  })

  const emit = defineEmits(['apply'])

  const { fullPath, hash } = useRoute()
  const { user } = useUser()
  const client = useStrapiClient()

  function redirect() {
    client(`/jobs/${props.job.id}/redirect`, { method: 'PUT' }).catch(error => handleError(error))
  }
</script>

<template>
  <div class="text-center">
    <div class="text-lg text-red-500" v-if="!job.isStatus('active')">L'offre est actuellement hors ligne.</div>
    <div class="text-lg text-red-500" v-else-if="job.isExpired()">La date limite de candidature est dépassée.</div>
    <template v-else>
      <a v-if="job.imported" :href="`mailto:${job.applicationEmail}?subject=${job.title}`">
        <Button
          class="border-2 bg-white !font-sans no-underline hover:shadow"
          v-if="isCareerSite"
          type="button"
          color="link"
          outline
          :style="{ borderColor: color }"
          >Postuler par email</Button
        >
        <Button v-else>Postuler par email</Button>
      </a>
      <NuxtLink v-else-if="job.isExternal()" target="_blank" :to="job.externalUrl">
        <Button
          class="border-2 bg-white !font-sans no-underline hover:shadow"
          v-if="isCareerSite"
          type="button"
          @click="redirect"
          color="link"
          outline
          aria-label="Postuler sur le site externe"
          :style="{ borderColor: color }"
          >Postuler</Button
        >
        <Button v-else @click="redirect" aria-label="Postuler sur le site externe">Postuler</Button>
      </NuxtLink>
      <template v-else-if="job.isStatus('active')">
        <Button
          v-if="!user && !isCareerSite"
          type="button"
          @click="askLogin(fullPath.replace(hash, '') + '#postuler')"
          aria-label="Se connecter pour postuler"
          >Postuler</Button
        >
        <Button
          class="border-2 bg-white !font-sans no-underline hover:shadow"
          v-else-if="isCareerSite"
          type="button"
          @click="$emit('apply')"
          color="link"
          outline
          :style="{ borderColor: color }"
          >Postuler</Button
        >
        <Button v-else-if="user?.candidate && !hasApplied" @click="$emit('apply')" aria-label="Postuler">Postuler</Button>
        <Tooltip v-else placement="top">
          <Button class="pointer-events-none opacity-50">Postuler</Button>
          <template v-if="!user?.candidate" #content>Vous n'avez pas d'espace candidat</template>
          <template v-else #content>Vous avez déjà postulé à cette offre</template>
        </Tooltip>
      </template>
    </template>
  </div>
</template>
